export const SERVER_ROOT = process.env.REACT_APP_QUEUE_SERVER ?? "";

export const PUBLIC_URL = process.env.PUBLIC_URL ?? "";

export const IMAGES_CDN = process.env.REACT_APP_IMAGES_CDN ?? "";
